import type { FC } from 'react';
import useIntercomStore from 'store/intercom.store';
import Dot from './Dot';

const IntercomUnreadDot: FC<{ className?: string }> = ({ className }) => {
  const unreadCount = useIntercomStore(({ unreadCount }) => unreadCount);

  if (!unreadCount || unreadCount < 0) return null;
  return <Dot className={className} />;
};

export default IntercomUnreadDot;
